import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import { Provider as ReduxProvider } from 'react-redux';
import store from './store';
import Pages from './pages';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance, msalInstanceInitCallback } from './services/auth';
import './utils/i18n/config';
import './index.css';

const render = (authInstance) => {
  const rootElement = document.getElementById('root');
  if (!rootElement) throw new Error('Failed to find the root element');
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <StrictMode>
      <MsalProvider instance={authInstance}>
        <ReduxProvider store={store}>
          <ThemeProvider theme={theme}>
            <Pages />
          </ThemeProvider>
        </ReduxProvider>
      </MsalProvider>
    </StrictMode>,
  );
};

msalInstance.initialize().then(() => msalInstanceInitCallback(msalInstance, render));
